import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { useModal } from '../../../../../components'
import { getProfissionalAtendimentosByFatura } from './_requests'
import { useParams } from 'react-router-dom'
import { FaturaProfissionalList } from './_models'

const QueryResponseContext = createResponseContext<FaturaProfissionalList>(initialQueryResponse)
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()
  const { idFatura } = useParams<{ idFatura: string }>()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  // A chave inclui a fatura: sem isso, faturas diferentes dividiam o cache.
  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.FATURAS_PROFISSIONAL_ATENDIMENTOS_LIST, idFatura, query],
    () => getProfissionalAtendimentosByFatura(Number(idFatura), query),
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !isOpen && Boolean(idFatura),
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
